import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PaginatedRevisionsContext } from '../../../shared/paginated-revisions';
import * as styles from './revisions.module.scss';
import PriorityTwoFailure from '../../announcement/priority-two-failure';
import { CircularProgress } from '@material-ui/core';
import useMeasuredRef from '../../../hooks/useMeasuredRef';
import Pagination from '../pagination/pagination';
import RevisionsTable from './revisions-table';
import usePaginatedRevisions from '../../../hooks/usePaginatedRevisions';
import PriorityTwoSuccess from '../../announcement/priority-two-success';

interface Props {
  isGlobal?: boolean;
}

const ManageRevisions = ({ isGlobal }: Props) => {
  const { snippetGroupId, clientId } = useParams();
  const { loading, results, pageSize, currentPage, totalResults } = React.useContext(PaginatedRevisionsContext);
  const {
    getGlobalRevisions,
    getClientRevisions,
    successMessage,
    errorMessage,
    setSuccessMessage,
    setErrorMessage
  } = usePaginatedRevisions();
  const { measuredRef, dimensions } = useMeasuredRef([results, successMessage, errorMessage], true);

  React.useEffect(() => {
    if (isGlobal) {
      getGlobalRevisions(Number(snippetGroupId), currentPage, pageSize);
    } else {
      getClientRevisions(Number(clientId), Number(snippetGroupId), currentPage, pageSize);
    }
  }, []);

  return (
    <div className={styles.container}>
      {successMessage && <PriorityTwoSuccess message={successMessage} />}
      {errorMessage && <PriorityTwoFailure message={errorMessage} />}
      {loading && results.length === 0 ? (
        <div className={styles.circularProgress}>
          <CircularProgress />
        </div>
      ) : !results || results.length === 0 ? (
        <span>There are no revisions.</span>
      ) : (
        <div
          className={styles.center}
          ref={measuredRef}
          style={{ height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px` }}
        >
          {(loading && results.length > 0) ||
            (loading && results.length === 0 && (
              <div className={styles.circularProgress}>
                <CircularProgress />
              </div>
            ))}
          <div className={styles.content} style={{ height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px` }}>
            <div>
              <span className={styles.resultsCount}>{totalResults} results</span>
            </div>
            <RevisionsTable
              clientId={Number(clientId)}
              loading={loading}
              isGlobal={isGlobal}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
            />
          </div>
          <Pagination
            fetchResults={({ pageSize, currentPage }) => {
              if (isGlobal) {
                getGlobalRevisions(Number(snippetGroupId), currentPage, pageSize);
              } else {
                getClientRevisions(Number(clientId), Number(snippetGroupId), currentPage, pageSize);
              }
            }}
            paginatedContext={PaginatedRevisionsContext}
            searchTerm={''}
            fetchExtraProps={{ clientId: clientId }}
          />
        </div>
      )}
    </div>
  );
};

export default ManageRevisions;
